import _ from '@/utils/lodash-optimized'
import { createSelector } from 'reselect'

import * as Compartment from './compartment.js'

export const getPrimaryCarePhysician = createSelector(
  [ Compartment.careTeams, Compartment.practitioners ],
  (careTeams, practitioners) => {
    if (!careTeams || !practitioners) {
      return null
    }
    // 1. Get Careteam named "Provider Network"
      const providerNetworkCareTeamParticipants = careTeams.find(ct => ct.name === 'Provider Network')?.participant
    // 2. Find the pcp role participant member
    const pcpId = _.chain(providerNetworkCareTeamParticipants)
        .find(p => p?.role?.text === 'PCP')
      .get('member.reference')
      .split('/')
      .last()
      .value()
    // 3. Find practitioner by pcpId
    return practitioners.find(p => p.id === pcpId)
  }
)

export const getPCPFirstName = createSelector(getPrimaryCarePhysician, pcp =>
    pcp?.name?.[0]?.given?.[0] ?? null)

export const getPCPLastName = createSelector(getPrimaryCarePhysician, pcp =>
    pcp?.name?.[0]?.family?.[0] ?? null)

export const getPCPNameSuffix = createSelector(getPrimaryCarePhysician, pcp =>
    pcp?.name?.[0]?.suffix?.[0] ?? null)

export const getPCPCredentials = createSelector(
  getPrimaryCarePhysician,
    pcp => pcp?.qualification?.[0]?.code?.text ?? null
)

export const getPCPFullNameAndCredentials = createSelector(
  [
    getPrimaryCarePhysician,
    getPCPFirstName,
    getPCPLastName,
    getPCPNameSuffix,
    getPCPCredentials
  ],
  (pcp, firstname, lastname, suffix, credentials) => {
    if (!pcp) {
      return null
    }
    if (suffix && credentials) {
      return `${firstname} ${lastname}, ${suffix} ${credentials}`
    }
    if (credentials) {
      return `${firstname} ${lastname}, ${credentials}`
    }
    if (suffix) {
      return `${firstname} ${lastname}, ${suffix}`
    }
    return `${firstname} ${lastname}`
  }
)
